import { render, staticRenderFns } from "./tempPelarasan072007.vue?vue&type=template&id=5cd27fdd&"
import script from "./tempPelarasan072007.vue?vue&type=script&lang=js&"
export * from "./tempPelarasan072007.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports